import React from "react";

import MailIcon from "public/icons/mail.svg";

import { Old_Button } from "@/components/form/Button/Old_Button";
import { SvgIcon } from "@/components/ui/svg-icon/SvgIcon";

/** @deprecated */
export const OLD_SideButtonsList: React.FC = () => {
  return (
    <ul
      data-testid="cardActionButtonsOLD"
      className="flex flex-col gap-2 absolute right-1 top-1"
    >
      <Old_Button
        data-testid="mailboxButton"
        variant="icon"
        className="bg-grey1-900 bg-opacity-20 w-10 h-10 p-2"
      >
        <SvgIcon color="white" className="w-full">
          <MailIcon />
        </SvgIcon>
      </Old_Button>
    </ul>
  );
};
